// cart drawer start
let cart_drawer = document.getElementById("sidebar-cart");
let cart_drawer_content = document.querySelector(
  '[data-armada-selector="cart-drawer-selector"] #drawer-cart-content'
);
let drawer_overlay = document.getElementById("drawer-overlay");
let cart_icon = document.querySelector("[data-action='open-cart-drawer']");
let close_cart_drawer = document.querySelector(
  '[data-action="close-drawer"][data-drawer-id="sidebar-cart"]'
);


const handleDrawerOpenChanges = (z, opacity, overflowElem, overflowVal) => {
  drawer_overlay.style.zIndex = z;
  drawer_overlay.style.opacity = opacity;
  overflowElem.style.overflow = overflowVal;
};
function openDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "false");
  handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
}
function closeDrawer(e) {
  e.preventDefault();
  cart_drawer.setAttribute("aria-hidden", "true");
  handleDrawerOpenChanges(-1, 0, document.body, "auto");
}
const keydownHandler = function (event) {
  if (event.key === "Escape" || event.keyCode === 27) {
    closeDrawer(event);
  }
};
const handleToggleDrawer = () => {
  if (cart_drawer.getAttribute("aria-hidden") == "true") {
    handleDrawerOpenChanges(200, 0.5, document.body, "hidden");
  } else {
    handleDrawerOpenChanges(-1, 0, document.body, "auto");
  }
};
let safeAreaListenerAdded = false;
const fetchCartDrawer = (openDrawer) => {
  fetch("/?view=cart")
    .then((res) => res.text())
    .then((html) => {
      if(!window.location.href.includes("/cart"))
      cart_drawer_content.innerHTML = html;
      openDrawer && cart_drawer.setAttribute("aria-hidden", "false");
    });
};

document.addEventListener("keydown", keydownHandler, false);
cart_icon?.addEventListener("click", (e) => openDrawer(e));
close_cart_drawer?.addEventListener("click", (e) => closeDrawer(e));
!window.location.href.includes("/cart") && drawer_overlay.addEventListener("click", (e) => closeDrawer(e));
// cart drawer end

const isMobileDevice =
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

const onWindowLoad = () => {
  fetchCartDrawer();

  let clickable_copy_code = document.querySelectorAll('.clickable-copy-code');

  clickable_copy_code.forEach((element) => {
    let code = element.querySelector('strong, b');
    let copy_icon = element.querySelector('#copy-icon');
    let check_icon = element.querySelector('#copy-check-icon');

    element.addEventListener('click', () => {
      navigator.clipboard.writeText(code.innerText);
      copy_icon.classList.add('icon-hidden');
      check_icon.classList.remove('icon-hidden');

      setTimeout(() => {
        check_icon.classList.add('icon-hidden');
        copy_icon.classList.remove('icon-hidden');
      }, 2000);
    });
  });
};

// Fitting box start
document.addEventListener("DOMContentLoaded", function() {
  const vtoTriggers = document.querySelectorAll('[data-vto-collection-trigger]');

  vtoTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      console.log("clicked")
      if(btn.dataset.vtoProduct){
        const p = JSON.parse(btn.dataset.vtoProduct);
        window.VTO_PRODUCT = p;
      }
      if(btn.dataset.vtoRecommendations){
        window.VTO_RECOMMENDATIONS = JSON.parse(btn.dataset.vtoRecommendations || '[]');
      }
      vtoOpen();
    })
  });
})

let fitmixInstance = null;
let vtoActiveProduct = null;
let vtoActiveSKU = null;
const vtoList = document.getElementById('vtoGlassesList');
const vtoAtcWrapper = document.querySelector('.add-to-cart-btn-1082');
// Build picker list
function createProductEl(p) {
  const el = document.createElement('div');
  el.className = 'vto-item';
  el.dataset.id = p.id;
  el.innerHTML = `
    <img class="vto-thumb" src="${p.img}" alt="${p.name}"/>
    <div class="vto-item-info">
      <div class="vto-item-name">${p.name}</div>
      <div class="vto-item-price">${p.price}</div>
    </div>`;
  el.addEventListener('click', () => vtoSelectProduct(p));
  return el;
}

function vtoSelectProduct(p) {
  document.querySelectorAll('.vto-item').forEach(el => el.classList.remove('active'));
  document.querySelector(`.vto-item[data-id="${p.id}"]`).classList.add('active');
  document.getElementById('vtoSelectedImg').src = p.img;
  document.getElementById('vtoSelectedName').textContent = p.name;
  document.getElementById('vtoSelectedCategory').textContent = p.type;
  document.getElementById('vtoSelectedPrice').innerHTML = p.price;
  if(document.getElementById('collection-view-product'))
    document.getElementById('collection-view-product').href = p.url;

  if (fitmixInstance) {
    console.log(fitmixInstance)
    if(p.sku)
      fitmixInstance.setFrame(p.sku);
  else 
    fitmixInstance.setFrame(p.variants[0].sku)
  }

  const isNewProduct = vtoActiveProduct?.id !== p.id;
  vtoActiveProduct = p;

  if (isNewProduct) {
    vtoReloadAtcButton(p);
    vtoUpdateLensAdvisor(p); // async, fire and forget is fine here
  }
}

async function vtoUpdateLensAdvisor(p) {
  const laBtn = document.getElementById('la-select-lenses-btn');
  if (!laBtn) return;

  const variantId = String(p.variantId || p.variant_id);
  const productId = String(p.id);

  // Fetch product JSON for LensAdvisor's connectedCallback
  const productJSON = await fetch(`/products/${p.handle}.js`)
    .then(r => r.json())
    .catch(err => { console.warn('VTO: product JSON fetch failed', err); return null; });

  if (!productJSON) return;

  if (!LensAdvizor.products[productId]) {
    const settingsUrl = LensAdvizor.addQueryParamsToURL(
      `${LensAdvizor.API_URL}/store/quick-buy-settings`,
      {
        store: Shopify.shop,
        product_flows: JSON.stringify([{ productId, flowId: '' }]),
        api_version: 2,
      }
    );

    await fetch(settingsUrl)
      .then(r => r.json())
      .then(data => {
        LensAdvizor.products = { ...LensAdvizor.products, ...data.products };
        if (!LensAdvizor.options) LensAdvizor.options = data;
      })
      .catch(err => console.warn('VTO: LensAdvisor settings fetch failed', err));
  }

  // Replace the element with updated attributes + pre-loaded productJSON
  const newBtn = laBtn.cloneNode(true);
  newBtn.setAttribute('data-la-variant-id', variantId);
  newBtn.setAttribute('data-la-product-id', productId);
  newBtn.setAttribute('data-la-product-handle', p.handle);
  newBtn.setAttribute('data-la-product-json', JSON.stringify(productJSON));

  laBtn.parentNode.replaceChild(newBtn, laBtn);
}

function vtoReloadAtcButton(p) {
  const btn = document.querySelector('.add-to-cart-btn-1082 [data-name="product-submit"]');
  if (!btn) return;

  btn.disabled = true;
  btn.classList.add('vto-btn-loading');

  setTimeout(() => {
    btn.disabled = false;
    btn.classList.remove('vto-btn-loading');
  }, 400);
}

const vtoParams = {
  apiKey: 'RBxfACeM4te59szAMSa6sAVKYFgE7HpwwFoeZQV1',
  onStopVto: () => {
    console.log("hello")
  },
  onIssue: (d) => console.warn('FitMix:', d),
};

window.addEventListener('load', function () {
  const fitmixContainer = document.getElementById("fitmix-container");
  if (fitmixContainer) {
    fitmixInstance = FitMix.createWidget('fitmix-container', vtoParams, function () {
      console.log('FitMix ready');
    });
  }
});

// Open / close
function vtoOpen() {
  vtoActiveProduct = window.VTO_PRODUCT;
  vtoActiveSKU = vtoActiveProduct.sku;

  console.log(vtoActiveProduct);

  // Rebuild the picker list fresh each open
  if (vtoList) {
    vtoList.innerHTML = '';
    vtoList.appendChild(createProductEl(vtoActiveProduct));
    (window.VTO_RECOMMENDATIONS || []).forEach(p => vtoList.appendChild(createProductEl(p)));
  }

  document.getElementById('vtoOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';

  if (window.innerWidth <= 640) {
    vtoOnboarding.classList.remove('done');
  }

  if (fitmixInstance) fitmixInstance.startVto('live');

  vtoSelectProduct(vtoActiveProduct);
}


function vtoClose() {
  if (window.fitmixInstance) fitmixInstance.stopVto();

  document.getElementById('vtoOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function vtoRestart(){
  if(fitmixInstance){
    fitmixInstance.restartVto();
  }
}

const vtoRestartBtn = document.getElementById('vtoRestartBtn');
vtoRestartBtn.addEventListener("click", vtoRestart)

// Trigger button
const submitImproveFit = document.getElementById('submit-pd');

// Close button
const vtoCloseBtn = document.getElementById('vtoCloseBtn');

if (vtoCloseBtn) vtoCloseBtn.addEventListener('click', () => {
  console.log('close clicked');
  vtoClose();
});

// Click outside modal to close
const vtoOverlay = document.getElementById('vtoOverlay');
if (vtoOverlay) vtoOverlay.addEventListener('click', function (e) {
  if (e.target === this) vtoClose();
});

// Escape key
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') vtoClose();
});

let vtoGender = null;
let vtoPD = null;

function vtoApplyUserInfo(gender, pd) {
  if (!fitmixInstance) return;
  const data = {};
  if (gender) data.gender = gender;
  if (pd)     data.pupillaryDistance = pd;
  if (Object.keys(data).length) fitmixInstance.setUserInfo(data);
}

const vtoOnboarding = document.getElementById('vtoMobileOnboarding');
const vtoOnboardingContinue = document.getElementById('vtoOnboardingContinue');
const vtoPdSelectOnboarding = document.getElementById('vtoPdSelectOnboarding');

vtoPdSelectOnboarding.addEventListener('change', e => vtoSyncPD(e.target.value));
vtoOnboardingContinue.addEventListener('click', () => {
  vtoOnboarding.classList.add('done');
});


function submitImproveFitAction(){
  vtoApplyUserInfo(vtoGender, vtoPD);
  document.getElementById('vtoFitDrawer').classList.remove('open');
}
submitImproveFit.addEventListener('click', submitImproveFitAction)

// Sync both selects (desktop + mobile drawer)
function vtoSyncPD(val) {
  vtoPD = val ? parseInt(val) : null;
  document.getElementById('vtoPdSelect').value = val;
  document.getElementById('vtoPdSelectMobile').value = val;
  document.getElementById('vtoPdSelectOnboarding').value = val;
}

// Sync both gender toggles
function vtoSyncGender(gender) {
  vtoGender = gender;
  document.querySelectorAll('.vto-gender-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.gender === gender);
  });
}

// Gender buttons (covers both desktop + drawer since same class)
document.querySelectorAll('.vto-gender-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    vtoSyncGender(btn.dataset.gender);
    // Apply immediately on desktop, defer to submit on mobile
    if (window.innerWidth > 640) {
      vtoApplyUserInfo(vtoGender, vtoPD);
    }
  });
});

// PD selects
document.getElementById('vtoPdSelect').addEventListener('change', e => {
  vtoSyncPD(e.target.value);
  vtoApplyUserInfo(vtoGender, vtoPD); // desktop only select — apply immediately
});
document.getElementById('vtoPdSelectMobile').addEventListener('change', e => vtoSyncPD(e.target.value));

// Mobile drawer open/close
document.getElementById('vtoImproveFitBtn').addEventListener('click', () => {
  document.getElementById('vtoFitDrawer').classList.add('open');
});
document.getElementById('vtoFitDrawerClose').addEventListener('click', () => {
  document.getElementById('vtoFitDrawer').classList.remove('open');
});

// Replace your existing ATC listener with this
if (vtoAtcWrapper) {
  vtoAtcWrapper.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-name="product-submit"]');

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = vtoActiveProduct?.variantId;
    if (!variantId) return console.warn('No VTO variant ID');

    // Manually trigger loading state on the button

    window.eight.cartEngine.addToCart(
      { items: [{ id: variantId, quantity: 1 }] },
      'items',
      () => {
        vtoClose();
        fetchCartDrawer(true);
      },
      (err) => {
        console.warn('VTO ATC error:', err);
        btn.disabled = false;
        if (span) span.textContent = 'Add to Cart';
      }
    );
  });
}

function initVtoTriggers() {
  document.querySelectorAll('[data-vto-collection-trigger]').forEach(btn => {
    btn.replaceWith(btn.cloneNode(true));
  });

  document.querySelectorAll('[data-vto-collection-trigger]').forEach(btn => {
    btn.addEventListener('click', () => {
      console.log('clicked')
      const card = btn.closest('[data-vto-product]');
      if (card) {
        window.VTO_PRODUCT = JSON.parse(card.getAttribute('data-vto-product'));
        window.VTO_RECOMMENDATIONS = JSON.parse(
          card.getAttribute('data-vto-recommendations') || '[]'
        );
      }
      vtoOpen(); // vtoList rebuild is already inside here
    });
  });
}

// Run on initial load
initVtoTriggers();

// Re-run whenever the collection grid is replaced
document.addEventListener('collectionGridUpdated', initVtoTriggers);

window.addEventListener("load", onWindowLoad, { passive: true });

// footer show/hide footer navigation list
const footer_titles = document.getElementsByClassName(
  "footer__heading-container"
);
const footer_navigation_ul = document.getElementsByClassName(
  "footer__navigation-ul"
);
const footer_navigation_plus_icon =
  document.getElementsByClassName("footer__plus-icon");

let result;

for (let i = 0; i < footer_titles.length; i++) {
  for (let j = 0; j < footer_navigation_ul.length; j++) {
    let title = footer_titles[i];
    let ul = footer_navigation_ul[j];
    let icon = footer_navigation_plus_icon[i];

    if (title.id == ul.getAttribute("data-id")) {
      isMobileDevice &&
        title.addEventListener(
          "click",
          () => {
            if (ul.style.display == "block") {
              ul.style.display = "none";
              icon.style.transform = "rotate(0deg)";
            } else {
              ul.style.display = "block";
              icon.style.transform = "rotate(45deg)";
            }
          },
          { passive: true }
        );
    }
  }
}

// Warranty Logic Start
// window.addEventListener("load", (event) => {
//   let warranty_check = document.getElementById("add-warranty");
//   if (
//     window.location.href.includes("/products/") &&
//     current_product.type.includes("sunglasses")
//   ) {
//     warranty_check.addEventListener("click", (e) => {
//       if (e.target.checked) {
//         localStorage.setItem(
//           "warrantySelected",
//           window.variantStrings.productId
//         );
//       } else {
//         localStorage.setItem("warrantySelected", e.target.checked);
//       }
//     });
//   }
// });


const filter_pills = document.querySelectorAll('.filter-pill');
if(filter_pills){
  Array.from(filter_pills).forEach(btn => {
    btn.addEventListener("click", (e) => {
      Array.from(filter_pills).forEach(btn => {
        btn.classList.remove('active')
      })
      e.target.classList.add('active')
    })
  })
}


(async () => {
  const links = document.querySelectorAll('.eu-withdrawal-link');
  if (!links.length) return;

  const EU_COUNTRIES = new Set([
    'AT','BE','BG','HR','CY','CZ','DE','DK','EE','ES','FI',
    'FR','GR','HU','IE','IT','LT','LU','LV','MT','NL','PL',
    'PT','RO','SE','SI','SK'
  ]);

  try {
    const res = await fetch('https://ipapi.co/json/');
    const { country_code } = await res.json();
    if (EU_COUNTRIES.has(country_code)) {
      links.forEach(el => el.style.display = 'block');
    }
  } catch (e) {
    // fail silently — link stays hidden
  }
})();
